import { useTranslations } from "contexts/LocalizationContext/hooks";
import { useModal } from "contexts/ModalContext";
import { trackUAEvent, trackCustomEvent } from "utils/tracking";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import isEmpty from "modules/storyblok/adapters/RichtextAdapter/utils/isEmpty";
import { contentStyles } from "modules/storyblok/adapters/Content";
import { SectionHeader } from "modules/common/components/SectionHeader";
import { MAX_GRID_WIDTH } from "config/styleConsts";
import { Box, Button, Image, Stack, Flex } from "@chakra-ui/react";
import { Modal } from "../../Modal";
import type { PreheaderSectionProps } from "../Sections.d";

const SHARE_NOW_HELP_A_FRIEND_EVENT_UA = ["clicked", "HelpAFriend", "Share_now"] as const;
const SHARE_NOW_HELP_A_FRIEND_EVENT = { event: "help_friend", label: "share_now", placement: "modal" } as const;

export const HelpAFriend = ({ preheader, title, content, buttonText, imgSrc }: PreheaderSectionProps) => {
  const translations = useTranslations();
  const { openModal } = useModal();

  const clickHandler = () => {
    openModal(<Modal />, "md");
    trackUAEvent(SHARE_NOW_HELP_A_FRIEND_EVENT_UA);
    trackCustomEvent(SHARE_NOW_HELP_A_FRIEND_EVENT);
  };

  return (
    <Flex
      mb={{ base: 14, md: 24 }}
      maxWidth={MAX_GRID_WIDTH}
      px={4}
      justify="space-between"
      direction={{ base: "column-reverse", md: "row" }}
      mx="auto"
      align="center"
    >
      <Box w={{ base: "100%", md: "50%" }} mt={{ base: 10, md: 0 }}>
        <Image
          data-testid="friend-img-at-airport"
          objectFit="cover"
          width="100%"
          boxShadow="sharpBlue"
          src={imgSrc}
          alt={translations("help_a_friend_image_alt")}
          title={translations("help_a_friend_image_alt")}
          loading="lazy"
          borderRadius="xl"
        />
      </Box>
      <Stack w={{ base: "100%", md: "40%" }} spacing={8} justify="center">
        <SectionHeader
          dataTestId="friend-header"
          header={title}
          preheader={preheader}
          alignItems="flex-start"
          spacing={2}
        />
        {!isEmpty(content) && <RichtextAdapter content={content} customStyles={contentStyles} />}
        <Button
          data-testid="friend-share-now"
          px={10}
          width={{ base: "100%", md: "fit-content" }}
          onClick={clickHandler}
          title={buttonText || translations("button_share_now")}
        >
          {buttonText || translations("button_share_now")}
        </Button>
      </Stack>
    </Flex>
  );
};
